import React from 'react';

const SuccessModal = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 animate-fadeIn">
      <div className="bg-white rounded-3xl shadow-custom-lg p-8 max-w-md mx-4 animate-slideUp">
        <div className="text-center">
          <div className="w-20 h-20 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center text-white text-4xl mx-auto mb-6 animate-bounce">
            <i className="fas fa-check"></i>
          </div>
          <h2 className="text-2xl font-black text-text mb-3">{message}</h2>
          <p className="text-text3 mb-6">جاري تحويلك للوحة التحكم...</p>
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
